import * as React from 'react';
import { Box, Button, Container } from '@mui/material';
import ShowcaseItem from "./showcaseItem"
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

export default function ShowcaseLayout({products, onClickItem}) {
    const scrollRef = React.useRef(null);


    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 350; // 每次滚动的像素，可调
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };
    return (
        <Box sx={{ position: 'relative', width: '83%', mt: 5 }}>
            {/* 左侧按钮 */}
            <Button
                onClick={() => scroll('left')}
                sx={{
                    borderRadius: "100%",
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.3)', // 自定义阴影
                    position: 'absolute',
                    top: '50%',
                    left: {xs: -20, sm: 20},
                    zIndex: 1,
                    transform: 'translateY(-50%)',
                    minWidth: 'auto',
                    backgroundColor: "#EF7F95"
                }}
            >
                <ChevronLeft style={{ color: "#FFFFFF" }}/>
            </Button>
            <Container
                ref={scrollRef}
                sx={{
                    display: 'flex',
                    alignItems: 'center',     // 垂直居中
                    overflowX: 'auto',
                    scrollBehavior: 'smooth',
                    '&::-webkit-scrollbar': { display: 'none' }, // 隐藏滚动条
                    marginTop: 5,
                    overscrollBehavior: 'none',
                    height: 'auto',
                    '& > :not(style)': {
                        m: 3,
                        width: 300,
                        height: 380,
                        flex: '0 0 auto',
                    },
                }}
            >
                {/* <ShowcaseItem onClick={onClickItem} productInfo={products[0]} />
                <ShowcaseItem onClick={onClickItem} productInfo={products[1]} />
                <ShowcaseItem onClick={onClickItem} productInfo={products[2]} />
                <ShowcaseItem onClick={onClickItem} productInfo={products[3]} /> */}
                {products.map((product, index) => (
                 <ShowcaseItem
                        key={index}
                        onClick={()=>onClickItem(index)}
                        productInfo={product}
                    />
                ))}
            </Container>
            {/* 右侧按钮 */}
            <Button
                onClick={() => scroll('right')}
                sx={{
                    borderRadius: "100%",
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.3)', // 自定义阴影
                    position: 'absolute',
                    top: '50%',
                    right: {xs: -20, sm: 20},
                    zIndex: 1,
                    transform: 'translateY(-50%)',
                    minWidth: 'auto',
                    backgroundColor: "#EF7F95"
                }}
            >
                <ChevronRight style={{color: "#FFFFFF"}} />
            </Button>
        </Box>
    );
}
